import React, { useState, useEffect } from 'react';
import FullBWSection from '../../components/FullBWsection';
import logoNero from '../../assets/staticSection/1.webp';
import family from '../../assets/staticSection/family12.webp';
import Navbar from '../../components/Navbar';
import headerImage from "../../assets/lingotti/0031B - Still life Care is gold-Modifica.webp";
import sarto from "../../assets/sarto/sarto1_crop.webp"
import FullMinimalSection from '../../components/FullMinimalSection';
import Footer from '../../components/Footer';
import { Helmet } from 'react-helmet';
import logo from '../../assets/oroPrestige/logo-trasp.webp'
import { ScrollParallax } from 'react-just-parallax';
import Static from '../../components/Static';
import AOS from 'aos';
import 'aos/dist/aos.css';



function Prodotti() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // togliere aos transition per mini-screen
  function initAOS() {
    AOS.init({
      disable: window.innerWidth <= 320 && window.innerHeight <= 256
    });
  }

  initAOS();

  window.addEventListener("resize", () => {
    AOS.refreshHard();
  });
  

  const title =<>
   Prodotti e servizi  
   <br />
   per ogni esigenza
   </>

  return (
    <div className="">
      <Helmet>
        <title>Prodotti e Servizi Oro | Careisgold SpA</title>
        <meta name="description" content="Esplora la gamma completa di prodotti e servizi oro di Careisgold. Lingotti certificati e soluzioni personalizzate per ogni esigenza. Lingotti accessibili a tutti, prima di tutti." />
        <meta name="keywords" content="prodotti, servizi, oro, lingotti oro, investimenti, oro fisico da investimento, Careisgold" />
        <meta property="og:title" content="Prodotti e Servizi Oro | Careisgold SpA" />
        <meta property="og:description" content="Esplora la gamma completa di prodotti e servizi oro di Careisgold. Lingotti certificati e soluzioni personalizzate per ogni esigenza. Lingotti accessibili a tutti, prima di tutti." />
        <meta property="og:image" content={headerImage} /> 
        <meta property="og:url" content="https://www.careisgold.it/prodotti-e-servizi/" />
        <meta property="og:type" content="page" /> 
        <link rel="canonical" href="https://www.careisgold.it/prodotti-e-servizi/" />
        <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Prodotti e Servizi Oro | Careisgold SpA",
            "url": "https://www.careisgold.it/prodotti-e-servizi/",
            "description": "Esplora la gamma completa di prodotti e servizi oro di Careisgold. Lingotti certificati e soluzioni personalizzate per ogni esigenza. Lingotti accessibili a tutti, prima di tutti.",
            "inLanguage": "it",
            "primaryImageOfPage": {
              "@type": "ImageObject",
              "url": "https://www.careisgold.it${headerImage}"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Careisgold SpA",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.careisgold.it${logo}"
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Via Monte Baldo 14/D",
                "addressLocality": "Villafranca di Verona",
                "addressRegion": "Veneto",
                "postalCode": "37069",
                "addressCountry": "IT"
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+39 045 8213155",
                "contactType": "Customer Service"
              },
              "sameAs": [
                "https://www.facebook.com/careisgoldspa",
                "https://www.instagram.com/careisgoldspa",
                "https://www.linkedin.com/company/careisgold-spa"
              ]
            }
          }
        `}
    </script>
      </Helmet>

      <Static
        headerImage={headerImage}
        title={title}
        description={`Careisgold offre un'ampia gamma di prodotti adattabili ad ogni necessità e servizi a 360 gradi per una gestione ottimale del proprio piano in oro fisico da investimento.`}
        arrow
        width='w-full'
        logoTransp=''
      />

      {/* PRIMO BLOCCO - PRODOTTI E LINGOTTI */}
      {width > 768 ?  <FullBWSection 
        background='bg-black'
        text='text-neutral-50'
        buttonClass1='w-full xl:w-2/3'
        darkButton={true}
        href='/prodotti/'
        title='Creiamo soluzioni su misura per te'
        description={`<p class=''>Come un sarto crea abiti su misura, anche noi adattiamo i nostri prodotti alle esigenze e ai
            desideri di ogni singolo cliente. Grazie alla sua esperienza pluriennale, Careisgold è in grado
            di offrire soluzioni affidabili, flessibili e innovative per la creazione della tua riserva aurea
            personale.</p>`}
        image={sarto}
        opacity='opacity-50'
        translate='lg:translate-x-[20%]'
        firstButtonText='Prodotti'
      /> :
      <FullMinimalSection 
        headerImage={sarto}
        logoTransp=''
        title='Creiamo soluzioni su misura per te'
        description={`Come un sarto crea abiti su misura, anche noi adattiamo i nostri prodotti alle esigenze e ai
            desideri di ogni singolo cliente. Grazie alla sua esperienza pluriennale, Careisgold è in grado
            di offrire soluzioni affidabili, flessibili e innovative per la creazione della tua riserva aurea
            personale.`}
        logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
        buttonText='Prodotti'
        darkButton={true}
        download={false}
        buttonClass='xl:w-2/3'
        href='/prodotti/'
      />
      }


      {/* SECCONDO BLOCCO - SERVIZI */}
      <FullMinimalSection
      headerImage={logoNero}
      logoTransp=''
      title='Servizi esclusivi sempre a tua disposizione'
      description={`Tutte le soluzioni Careisgold sono affiancate a servizi di primo livello per garantire un supporto completo e
                    personalizzato ad ogni cliente e soddisfare ogni tipo di esigenza legata al tuo piano in Oro.`}
      buttonText='SCOPRI TUTTI I SERVIZI CAREISGOLD'
      darkButton={true}
      download={false}
      buttonClass='w-full xl:w-2/3'
      href='/servizi/'
      />

      {/* TERZO BLOCCO - CONSULENZA E SUPPORTO */}
      
      {width > 768 ? <FullBWSection 
        background='bg-black'
        text='text-slate-50'
        buttonClass1='w-full xl:w-2/3'
        buttonClass2='hidden'
        darkButton={true}
        href2=''
        href='/consulenza-supporto/'
        title='Pensiamo a tutto noi'
        description={`<p>Il tuo Oro è prezioso, ma non pesante. Careisgold solleva il cliente da ogni
          impellenza burocratica, occupandosi di ogni dettaglio amministrativo e normativo. Inoltre,
          hai il tuo esperto sempre a disposizione e strumenti digitali dedicati per monitorare il
          tuo piano 24 ore su 24.</p>`}
        image={family}
        opacity='opacity-50'
        translate='lg:translate-x-[20%]'
        firstButtonText='Scopri di più'
      /> :
      <FullMinimalSection 
        headerImage={family}
        logoTransp=''
        title='Pensiamo a tutto noi'
        description={`Il tuo Oro è prezioso, ma non pesante. Careisgold solleva il cliente da ogni
          impellenza burocratica, occupandosi di ogni dettaglio amministrativo e normativo. Inoltre,
           hai il tuo esperto sempre a disposizione e strumenti digitali dedicati per monitorare il
          tuo piano 24 ore su 24.`}
        logoPosition='left-[-40vh] top-[-30vh] w-[110vh]'
        buttonText='Scopri di più'
        darkButton={true}
        download={false}
        buttonClass='xl:w-2/3'
        buttonClass2='hidden'
        href='/consulenza-supporto/'
      />
       }

    </div>
  )
}

export default Prodotti